import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=4fd00bb0"
import script from "./SessionCard.vue?vue&type=script&lang=ts"
export * from "./SessionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports